export default function parseLocaleNumber(numberStr, fixed) {

    if (!isNaN(numberStr)) {
        numberStr = numberStr.toString();
    }

    // Validate input: must be a string and not empty
    if (typeof numberStr !== 'string' || numberStr.trim() === '') {
        return { value: null, valueString: null };
    }

    // Replace a single comma with a dot for locale formatting
    let normalizedStr = numberStr.replace(',', '.');

    // Parse the normalized string into a float
    let parsedNumber = parseFloat(normalizedStr);

    // Check if parsing was successful
    if (isNaN(parsedNumber)) {
        return { value: null, valueString: null };
    }

    // Default to the raw string representation of the number
    let valueString = parsedNumber.toString();

    // Handle the `fixed` parameter for decimal precision
    if (fixed != null && fixed !== 'null') {
        try {
            // Determine the number of decimal places to fix
            let decimalPlaces = isNaN(parseInt(fixed)) ? 2 : parseInt(fixed);
            valueString = parsedNumber.toFixed(decimalPlaces);

            // Ensure valueString remains a string and not NaN
            valueString = isNaN(valueString) ? '' : valueString.toString();

        } catch (e) {
            console.error("Error formatting number:", e);
        }
    }

    // Optional: Restore comma for locale representation
    if (numberStr.includes(',')) {
        valueString = valueString.replace('.', ',');
    } else if (numberStr.includes('.')) {
        valueString = valueString.replace('.', '.');
    } else {
        try {

            if (current_language == 'de') {
                valueString = valueString.replace('.', ',');
            }

        } catch (e) {

        }
    }

    // Return both the parsed value and the formatted string
    return { value: parsedNumber, valueString: valueString };
};